export default __webpack_public_path__ + "static/media/upsy-daisy.830d88ae.png";